import type { QuickBooksControlCenterQuery } from '.';

// GET /control-center/needs-attention accepts scope only: its querystring
// schema (qb-worker src/schemas/quickbooks.js
// controlCenterNeedsAttentionQuery) is { realmId, environment } with
// additionalProperties false. cacheCompanyId is the client's cache identity
// and is never sent; nothing else is forwarded either.
export const controlCenterNeedsAttentionSearch = (
  query?: Pick<
    QuickBooksControlCenterQuery,
    'realmId' | 'environment' | 'cacheCompanyId'
  > | void
) =>
  new URLSearchParams(
    Object.entries({
      realmId: query ? query.realmId : undefined,
      environment: query ? query.environment : undefined,
    }).filter((entry): entry is [string, string] => Boolean(entry[1]))
  ).toString();
